<div class="video external">
  <iframe
    *ngIf="activated"
    [src]="'//player.vimeo.com/video/' + code + '?autoplay=' + autoplay | safeUrl"
    frameborder="0"
    allow="autoplay; encrypted-media"
    allowfullscreen
  ></iframe>
  <div class="video-thumbnail" *ngIf="!activated" (click)="activate()">
    <img [src]="poster" />
  </div>
</div>
